import { API_URL } from '../constants/config'
import { query } from './utilities'

export const fetchOpportunityInfo = (opportunityId) =>
  query(`${API_URL}/Opportunity/${opportunityId}/info/oly`)
   

export const fetchIndividualEstimate = (opportunityId, estimateId, isProposal, updateAnalytics, accessToken) =>
  query(
    `${API_URL}/Opportunity/${opportunityId}/quote/${estimateId}/${isProposal}/${updateAnalytics}/oly`,
    {},
    accessToken
  )

export const fetchEstimates = (opportunityId) =>
  query(`${API_URL}/Opportunity/${opportunityId}/oly`)
